var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReschedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.7148,
    cy: 22.5,
    r: 22.5,
    fill: "#001CB2",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3633 18.7766V16.5872C14.3633 15.1567 15.5226 13.999 16.9515 13.999H30.0441C31.4746 13.999 32.6323 15.1583 32.6323 16.5872V18.7766M30.0441 32.268H16.9515C15.5209 32.268 14.3633 31.1088 14.3633 29.6799V18.7782H32.6339V29.6799C32.6339 31.1104 31.4746 32.268 30.0457 32.268H30.0441Z",
    stroke: "#001CB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6641 15.3229V12.7314",
    stroke: "#001CB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 15.3229V12.7314",
    stroke: "#001CB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1758 25.7925L21.0099 27.6267C21.3878 28.0045 22.0013 28.0045 22.3791 27.6267L27.8251 22.1807",
    stroke: "#001CB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReschedule);
export default __webpack_public_path__ + "static/media/reschedule.3b3a0cd8f25a916f4024a33a28c77919.svg";
export { ForwardRef as ReactComponent };